import React from 'react';
import { useNavigate } from "react-router-dom";
import { LogOut, Wifi } from "lucide-react";
import "./Dashboardheaders.css";

function Dashboardheader() {
    const navigate = useNavigate();
    const userRole = sessionStorage.getItem("role");

    const handleLogout = () => {
        sessionStorage.clear();
        navigate("/", { replace: true });
    };

    const handleLogoClick = () => {
        if (userRole === "admin") {
            navigate("/admin");
        } else if (userRole === "user") {
            navigate("/user");
        } else {
            navigate("/");
        }
    };

    return (
        <header className="dashboard-navbar">
            <div className="navbar-container">
                <div className="navbar-logo" onClick={handleLogoClick}>
                    <div className="logo-icon-wrapper">
                        <Wifi className="logo-wifi-icon" />
                    </div>
                    <span className="logo-brand">RiTU</span>
                    <span className="logo-sub">BROAD BAND</span>
                </div>
                <div className="navbar-actions">
                    <button type="button" onClick={handleLogout} className="btn-logout">
                        <span>Logout</span>
                        <LogOut size={16} />
                    </button>
                </div>
            </div>
        </header>
    );
}

export default Dashboardheader;